enum Step {
  SELECT_CARD_TYPE,
  CONFIGURE_CARD,
}

export default Step;
